msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: zh-CN\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: invite.inviter_name
#: src/components/InviteLanding.tsx
msgid "{0} invited you to this Project."
msgstr "{0} 邀请你加入此项目。"

#: src/components/InviteLanding.tsx
msgid "Accept invitation"
msgstr "接受邀请"

#: src/components/InviteLanding.tsx
msgid "Add selected agents"
msgstr "添加选中的 Agent"

#: src/components/RegisterPage.tsx
msgid "Already have an account? Log in"
msgstr "已有账号？登录"

#: src/i18n/authMessages.ts
msgid "An account with this email already exists. Try signing in."
msgstr "该邮箱已注册，请尝试登录。"

#: src/i18n/authMessages.ts
msgid "Borgee cannot create an account for this Microsoft account: it has no name or email address to show. Add one to your Microsoft profile, or use password login."
msgstr "此 Microsoft 账号没有可显示的姓名或邮箱，Borgee 无法为其创建账号。请完善 Microsoft 个人资料，或使用密码登录。"

#: src/i18n/authMessages.ts
msgid "Borgee could not create a local session. Please try again."
msgstr "Borgee 无法创建本地会话，请重试。"

#: src/components/InviteLanding.tsx
msgid "Bring your agents"
msgstr "带上你的 Agent"

#: src/components/LoginPage.tsx
msgid "Continue with Microsoft"
msgstr "使用 Microsoft 继续"

#: src/components/InviteLanding.tsx
msgid "Could not add the selected agents. Please try again."
msgstr "无法添加选中的 Agent，请重试。"

#: src/i18n/authMessages.ts
msgid "Could not create your account. Check your details and invite code."
msgstr "无法创建账号，请检查填写的信息和邀请码。"

#: src/i18n/authMessages.ts
msgid "Could not create your account. Please try again."
msgstr "无法创建账号，请重试。"

#: src/i18n/authMessages.ts
msgid "Could not sign in. Please try again."
msgstr "无法登录，请重试。"

#: src/components/RegisterPage.tsx
msgid "Create Account"
msgstr "创建账号"

#: src/components/RegisterPage.tsx
msgid "Creating account..."
msgstr "正在创建账号..."

#: src/components/RegisterPage.tsx
msgid "Display Name"
msgstr "显示名称"

#: src/components/RegisterPage.tsx
msgid "Display name must be 1-50 characters"
msgstr "显示名称必须为 1–50 个字符"

#: src/components/LoginPage.tsx
#: src/components/RegisterPage.tsx
msgid "Email"
msgstr "邮箱"

#: src/components/LoginPage.tsx
msgid "Have an invite code? Register"
msgstr "有邀请码？注册"

#: src/components/RegisterPage.tsx
msgid "Invalid email format"
msgstr "邮箱格式不正确"

#: src/components/RegisterPage.tsx
msgid "Invite Code"
msgstr "邀请码"

#. placeholder {0}: invite.guild_name
#: src/components/InviteLanding.tsx
msgid "Join {0}"
msgstr "加入 {0}"

#: src/components/InviteLanding.tsx
msgid "Loading invitation…"
msgstr "正在加载邀请…"

#: src/components/LoginPage.tsx
msgid "Log in"
msgstr "登录"

#: src/components/LoginPage.tsx
msgid "Logging in..."
msgstr "正在登录..."

#: src/i18n/authMessages.ts
msgid "Microsoft could not verify this sign-in. Please start again."
msgstr "Microsoft 无法验证此次登录，请重新开始。"

#: src/i18n/authMessages.ts
msgid "Microsoft could not verify this sign-in. Please try again."
msgstr "Microsoft 无法验证此次登录，请重试。"

#: src/i18n/authMessages.ts
msgid "Microsoft sign-in could not be completed. Password login still works."
msgstr "无法完成 Microsoft 登录，仍可使用密码登录。"

#: src/i18n/authMessages.ts
msgid "Microsoft sign-in is not enabled. Password login still works."
msgstr "尚未启用 Microsoft 登录，仍可使用密码登录。"

#: src/i18n/authMessages.ts
msgid "Microsoft sign-in is temporarily busy. Please try again."
msgstr "Microsoft 登录暂时繁忙，请重试。"

#: src/i18n/authMessages.ts
msgid "Microsoft sign-in is temporarily unavailable. Password login still works."
msgstr "Microsoft 登录暂时不可用，仍可使用密码登录。"

#: src/i18n/authMessages.ts
msgid "Microsoft sign-in was cancelled."
msgstr "已取消 Microsoft 登录。"

#: src/components/InviteLanding.tsx
msgid "No eligible active agents are available."
msgstr "没有符合条件且已启用的 Agent。"

#: src/components/LoginPage.tsx
msgid "or"
msgstr "或"

#: src/components/LoginPage.tsx
#: src/components/RegisterPage.tsx
msgid "Password"
msgstr "密码"

#: src/components/RegisterPage.tsx
msgid "Password must be at least 8 bytes"
msgstr "密码至少需要 8 个字节"

#: src/components/RegisterPage.tsx
msgid "Password must be at most 72 bytes"
msgstr "密码最多允许 72 个字节"

#: src/components/RegisterPage.tsx
msgid "Register"
msgstr "注册"

#: src/components/InviteLanding.tsx
msgid "Select active agents to add to this Project. None are selected by default."
msgstr "选择要添加到此项目的已启用 Agent，默认不选中任何 Agent。"

#: src/i18n/authMessages.ts
msgid "Sign-in was not accepted. Check your credentials or contact an administrator."
msgstr "登录未被接受，请检查凭据或联系管理员。"

#: src/components/InviteLanding.tsx
msgid "Skip"
msgstr "跳过"

#: src/i18n/authMessages.ts
msgid "This email already belongs to a Borgee account. Continue with password login."
msgstr "此邮箱已关联 Borgee 账号，请使用密码登录。"

#: src/components/InviteLanding.tsx
msgid "This invitation is unavailable."
msgstr "此邀请不可用。"

#: src/i18n/authMessages.ts
msgid "This invite code is invalid or no longer available. Request a new invite code."
msgstr "此邀请码无效或已不可用，请申请新的邀请码。"

#: src/i18n/authMessages.ts
msgid "This Microsoft account belongs to a deleted Borgee account."
msgstr "此 Microsoft 账号关联的 Borgee 账号已被删除。"

#: src/i18n/authMessages.ts
msgid "This Microsoft sign-in link expired. Please start again."
msgstr "此 Microsoft 登录链接已过期，请重新开始。"

#: src/i18n/authMessages.ts
msgid "This Microsoft sign-in link is invalid or has already been used."
msgstr "此 Microsoft 登录链接无效或已被使用。"

#: src/i18n/authMessages.ts
msgid "This Microsoft sign-in return path is invalid. Please start again."
msgstr "此次 Microsoft 登录的返回路径无效，请重新开始。"

#: src/i18n/authMessages.ts
msgid "Too many registration attempts. Please try again later."
msgstr "注册尝试过于频繁，请稍后重试。"

#: src/i18n/authMessages.ts
msgid "Too many sign-in attempts. Please try again later."
msgstr "登录尝试过于频繁，请稍后重试。"

#: src/i18n/authMessages.ts
msgid "Your session ended. Sign in again."
msgstr "会话已结束，请重新登录。"
